/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { DataRequestCreateRequest } from '../model';
// @ts-ignore
import { DataRequestPreview } from '../model';
// @ts-ignore
import { DataRequestPreviewRequest } from '../model';
// @ts-ignore
import { DataRequestRead } from '../model';
// @ts-ignore
import { PaginatedDataRequestReadList } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * OrganisationBookingDataRequestOutgoingApi - axios parameter creator
 * @export
 */
export const OrganisationBookingDataRequestOutgoingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A Booking Data Request can only be created when the status of the Booking == OPEN
         * @summary Create a Booking Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {DataRequestCreateRequest} dataRequestCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestCreate: async (bookingId: string, buyerOrgId: string, dataRequestCreateRequest: DataRequestCreateRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'dataRequestCreateRequest' is not null or undefined
            assertParamExists('orgBookingDataRequestCreate', 'dataRequestCreateRequest', dataRequestCreateRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataRequestCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the outgoing Booking Data Requests.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestList: async (bookingId: string, buyerOrgId: string, aaSource?: string, page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestList', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The data used for the template is from the latest Booking version.
         * @summary Generates an SMS preview that goes out to the booking contact.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {DataRequestPreviewRequest} dataRequestPreviewRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestPreviewCreate: async (bookingId: string, buyerOrgId: string, dataRequestPreviewRequest: DataRequestPreviewRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestPreviewCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestPreviewCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'dataRequestPreviewRequest' is not null or undefined
            assertParamExists('orgBookingDataRequestPreviewCreate', 'dataRequestPreviewRequest', dataRequestPreviewRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/preview`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataRequestPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
         * @summary Resend a Data Request SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestResendCreate: async (bookingId: string, buyerOrgId: string, requestId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestResendCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestResendCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('orgBookingDataRequestResendCreate', 'requestId', requestId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/{request_id}/resend`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get details about a single Booking Data Request.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestRetrieve: async (bookingId: string, buyerOrgId: string, requestId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestRetrieve', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('orgBookingDataRequestRetrieve', 'requestId', requestId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/{request_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationBookingDataRequestOutgoingApi - functional programming interface
 * @export
 */
export const OrganisationBookingDataRequestOutgoingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationBookingDataRequestOutgoingApiAxiosParamCreator(configuration)
    return {
        /**
         * A Booking Data Request can only be created when the status of the Booking == OPEN
         * @summary Create a Booking Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {DataRequestCreateRequest} dataRequestCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestCreate(bookingId: string, buyerOrgId: string, dataRequestCreateRequest: DataRequestCreateRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataRequestRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestCreate(bookingId, buyerOrgId, dataRequestCreateRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the outgoing Booking Data Requests.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestList(bookingId: string, buyerOrgId: string, aaSource?: string, page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDataRequestReadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestList(bookingId, buyerOrgId, aaSource, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The data used for the template is from the latest Booking version.
         * @summary Generates an SMS preview that goes out to the booking contact.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {DataRequestPreviewRequest} dataRequestPreviewRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestPreviewCreate(bookingId: string, buyerOrgId: string, dataRequestPreviewRequest: DataRequestPreviewRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataRequestPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestPreviewCreate(bookingId, buyerOrgId, dataRequestPreviewRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
         * @summary Resend a Data Request SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestResendCreate(bookingId: string, buyerOrgId: string, requestId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestResendCreate(bookingId, buyerOrgId, requestId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get details about a single Booking Data Request.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestRetrieve(bookingId: string, buyerOrgId: string, requestId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataRequestRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestRetrieve(bookingId, buyerOrgId, requestId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationBookingDataRequestOutgoingApi - factory interface
 * @export
 */
export const OrganisationBookingDataRequestOutgoingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationBookingDataRequestOutgoingApiFp(configuration)
    return {
        /**
         * A Booking Data Request can only be created when the status of the Booking == OPEN
         * @summary Create a Booking Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {DataRequestCreateRequest} dataRequestCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestCreate(bookingId: string, buyerOrgId: string, dataRequestCreateRequest: DataRequestCreateRequest, aaSource?: string, options?: any): AxiosPromise<DataRequestRead> {
            return localVarFp.orgBookingDataRequestCreate(bookingId, buyerOrgId, dataRequestCreateRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the outgoing Booking Data Requests.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestList(bookingId: string, buyerOrgId: string, aaSource?: string, page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedDataRequestReadList> {
            return localVarFp.orgBookingDataRequestList(bookingId, buyerOrgId, aaSource, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * The data used for the template is from the latest Booking version.
         * @summary Generates an SMS preview that goes out to the booking contact.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {DataRequestPreviewRequest} dataRequestPreviewRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestPreviewCreate(bookingId: string, buyerOrgId: string, dataRequestPreviewRequest: DataRequestPreviewRequest, aaSource?: string, options?: any): AxiosPromise<DataRequestPreview> {
            return localVarFp.orgBookingDataRequestPreviewCreate(bookingId, buyerOrgId, dataRequestPreviewRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
         * @summary Resend a Data Request SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestResendCreate(bookingId: string, buyerOrgId: string, requestId: string, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orgBookingDataRequestResendCreate(bookingId, buyerOrgId, requestId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get details about a single Booking Data Request.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestRetrieve(bookingId: string, buyerOrgId: string, requestId: string, aaSource?: string, options?: any): AxiosPromise<DataRequestRead> {
            return localVarFp.orgBookingDataRequestRetrieve(bookingId, buyerOrgId, requestId, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgBookingDataRequestCreate operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {DataRequestCreateRequest}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreate
     */
    readonly dataRequestCreateRequest: DataRequestCreateRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingDataRequestList operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly aaSource?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly pageSize?: number
}

/**
 * Request parameters for orgBookingDataRequestPreviewCreate operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreateRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {DataRequestPreviewRequest}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreate
     */
    readonly dataRequestPreviewRequest: DataRequestPreviewRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingDataRequestResendCreate operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreate
     */
    readonly requestId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgBookingDataRequestRetrieve operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieve
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieve
     */
    readonly requestId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieve
     */
    readonly aaSource?: string
}

/**
 * OrganisationBookingDataRequestOutgoingApi - object-oriented interface
 * @export
 * @class OrganisationBookingDataRequestOutgoingApi
 * @extends {BaseAPI}
 */
export class OrganisationBookingDataRequestOutgoingApi extends BaseAPI {
    /**
     * A Booking Data Request can only be created when the status of the Booking == OPEN
     * @summary Create a Booking Data Request
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestCreate(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.dataRequestCreateRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Returns all the outgoing Booking Data Requests.
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestList(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestList(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.aaSource, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The data used for the template is from the latest Booking version.
     * @summary Generates an SMS preview that goes out to the booking contact.
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestPreviewCreate(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewCreateRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestPreviewCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.dataRequestPreviewRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
     * @summary Resend a Data Request SMS
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestResendCreate(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestResendCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.requestId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get details about a single Booking Data Request.
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestRetrieve(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.requestId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
